import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ReplaySubject, takeUntil } from 'rxjs';

import { coreSelectors } from 'app/core/state';
import { AppState } from 'app/types';
import { Loggable } from 'app/utils/logging/loggable';
import Social from 'entity/Social';
import User from 'entity/User';

@Component({
  selector: 'app-waiting-room',
  templateUrl: './waiting-room.component.html',
  styleUrls: ['./waiting-room.component.scss'],
  standalone: false,
})
export class WaitingRoomComponent extends Loggable implements OnInit, OnDestroy {
  private social?: Social;
  public user?: User;
  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor(
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private store: Store<AppState>,
  ) {
    super();
    this.setDisplayName('WaitingRoomComponent');
    this.store
      .select(coreSelectors.getUserEntity)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((user) => (this.user = user));
  }

  public ngOnInit(): void {
    const title = 'Scoot';
    this.titleService.setTitle(title);
    this.social = this.route.snapshot.data['social'];

    if (!this.social) {
      this.router.navigate(['404']).catch((err) => this.error('error navigating to 404', err));
    }
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
